export default __webpack_public_path__ + "static/media/img_background.e6680441.gif";